module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('ul', {
    staticClass: "nav",
    class: [_vm.seType, _vm.setStyle]
  }, _vm._l((_vm.data), function(nav, index) {
    return _c('li', {
      class: {
        active: _vm.isActive == index
      },
      on: {
        "click": function($event) {
          _vm.changeNav(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": nav.href
      }
    }, [_vm._v(_vm._s(nav.name))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-294b6d5a!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/nav.vue
// module id = 299
// module chunks = 2